export default class BaseService {
  constructor (data) {
    this._data = data
  }

  install (Vue) {
    this._vm = new Vue({
      data: this.data
    })
  }

  get data () {
    return this._data
  }
}



// WEBPACK FOOTER //
// ./src/service/BaseService.js